import React from "react";
import "../styles/services.css";

const services = [
    {
        title: "SPA Massage",
        description:
            "Relax your mind and body with our signature aromatherapy massage using essential oils designed to restore balance and peace.",
        image: "/images/aromatherapy.png",
        price: 65,
    },
    {
        title: "Facial Treatments",
        description:
            "Rejuvenate your skin with our specialized facial treatments tailored to your skin type, leaving you refreshed and glowing.",
        image: "/images/facial.jpeg",
        price: 65,
    },
    {
        title: "RMT Massage",
        description:
            "Melt away stress with the healing warmth of hot stones combined with soothing massage techniques.",
        image: "/images/hotstone.jpg",
        price: 20,
    },
    {
        title: "Acupuncture",
        description:
            "Experience the healing benefits of traditional acupuncture for mind and body balance.",
        image: "/images/acupuncture.jpg",
        price: 120,
    }, {
        title: "Osteopathic Massage",
        description:
            "Melt away stress with the healing warmth of hot stones combined with soothing massage techniques.",
        image: "/images/osteopathic.jpeg",
        price: 120,
    },
];

const Services: React.FC = () => {
    return (
        <section id="services" className="services">
            <h2 className="section-title">Our Services</h2>
            <hr className="fancy-hr" />
            <div className="feature-services-grid">
                {services.map((service, index) => (
                    <div key={index} className="feature-service-card">
                        <div className="feature-service-image">
                            <img src={service.image} alt={service.title} />
                            <div className="service-overlay">
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {/* <button className="more-services-btn" onClick={() => navigate("/services")}>
                More Services
            </button> */}
        </section>
    );
};

export default Services;
